import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/modules/api";
import { extractListData } from "@/modules/api/response-helpers";

interface SpaceResponse {
  id: string;
  is_primary_space?: boolean;
}

interface SpaceAccountResponse {
  id: string;
  space_id?: string | null;
}

export const usePrimarySpaceAccountId = () => {
  const spacesQuery = useQuery({
    queryKey: ["spaces", "me"],
    queryFn: () => api.get("/v1/me/spaces", {}),
  });

  const spaceAccountsQuery = useQuery({
    queryKey: ["space-accounts", "me"],
    queryFn: () => api.get("/v1/me/space-accounts", {}),
  });

  const primarySpaceAccountId = useMemo(() => {
    const spacesResponse = spacesQuery.data;
    const spaceAccountsResponse = spaceAccountsQuery.data;

    if (!spacesResponse?.data || !spaceAccountsResponse?.data) {
      return null;
    }

    const spaces = extractListData<SpaceResponse>(spacesResponse.data);
    const spaceAccounts = extractListData<SpaceAccountResponse>(spaceAccountsResponse.data);

    if (!spaces.length || !spaceAccounts.length) {
      return null;
    }

    const primarySpace = spaces.find(space => space.is_primary_space);
    if (!primarySpace) {
      return null;
    }

    const primarySpaceAccount = spaceAccounts.find(
      spaceAccount => spaceAccount.space_id === primarySpace.id
    );

    return primarySpaceAccount?.id ?? null;
  }, [spacesQuery.data, spaceAccountsQuery.data]);

  const isLoading = spacesQuery.isLoading || spaceAccountsQuery.isLoading;

  return {
    primarySpaceAccountId,
    isLoading,
  };
};
